/* eslint-disable */
import React, { useState } from 'react';
import {
  FormProvider, SubmitHandler, useForm,
} from 'react-hook-form';
import * as yup from 'yup';
import useYupValidationResolver from 'src/hooks/useYupValidationResolver';
import RHFEditor from '../elements/Editor/RHFEditor';
import { Button, Paper } from '@mui/material';
import { CloseIcon } from 'src/icons';

interface CommentsProps {
  title?: string;
  onSubmit: (data: any) => void;
  onCancel: () => void;
}

export interface CommentsFormValues {
  comments: '',
}

const validationSchema = yup.object().shape({
  comments: yup.string().required('Comments Required'),
});

const Comments = function Comments(props: CommentsProps) {
  const [disableSubmit, setDisableSubmit] = useState<boolean>(false);
  const { title, onCancel, onSubmit } = props;

  const resolver = useYupValidationResolver(validationSchema);
  const methods = useForm<CommentsFormValues>({
    resolver,
  });
  const {
    handleSubmit,
  } = methods;

  const submitHandler: SubmitHandler<CommentsFormValues> = async (data) => {
    setDisableSubmit(true);
    try {
      await onSubmit(data);
    } catch (e) {
      console.info(e);
    } finally {
      setDisableSubmit(false);
    }
  };

  return (
    <Paper>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(submitHandler)}>
          <div className="flex justify-center items-center w-full h-[60px] py-10 text-[#28364C] font-medium text-base pl-[13px]">
            {title}
          </div>

          <div className="items-start w-full px-10">
            <div className="items-start w-full text-[#28364C] font-semibold text-base">Comments</div>
            <RHFEditor
              editorType="classic"
              name="comments"
              control={methods.control}
              disabled={false}
              height={300}
            />
          </div>

          <div className="w-full flex gap-2 p-10">
            <Button variant="contained" type="submit" size="small" className="font-medium rounded-full" disabled={disableSubmit}>Submit</Button>
            <Button variant="outlined" size="small" className="font-medium rounded-full" onClick={onCancel} disabled={disableSubmit}>Cancel</Button>
          </div>

          <div
            className="absolute right-2 top-2"
            onClick={onCancel}
          >
            <CloseIcon className="cursor-pointer" />
          </div>
        </form>
      </FormProvider>
    </Paper>
  );
};

export default Comments;
